<template>
  <div class="wapper">
    <el-page-header @back="goBack"
                    content="合约公司详情"
                    class="header">
    </el-page-header>
    <div class="content-wapper"
         v-if="null != info">
      <span class="title">合约公司基础信息</span>
      <ul class="info-wapper">
        <li>
          <div>
            <label>合约公司名称</label>
            <span>{{info.name}}</span>
          </div>
          <div>
            <label>合约公司状态</label>
            <span>{{info.stateValue}}</span>
          </div>
        </li>
        <li>
          <div>
            <label>创建人</label>
            <span>{{info.creatorName}}</span>
          </div>
          <div>
            <label>创建时间</label>
            <span>{{info.gmtCreate}}</span>
          </div>
          <div v-if="superRole == 3">
            <label>所属渠道</label>
            <span>{{info.channelName}}</span>
          </div>
        </li>
        <li>
          <div>
            <label>开票公司标识</label>
            <span>{{info.id}}</span>
          </div>
          <div>
            <label>最后修改时间</label>
            <span>{{info.gmtModified}}</span>
          </div>
        </li>
        <li>
          <div class="orderType">
            <label> 支持订单类型</label>
            <span>{{info.availableOrderTypeName}}</span>
          </div>
        </li>
        <li>
          <div class="special">
            <label>备注说明</label>
            <span class="textarea">{{info.remarks}}</span>
          </div>
        </li>
      </ul>
      <div class="images-wapper">
        <span class="title">发票类型设置</span>
        <div class="table-wapper">
     
          <table>
              <tr>
                <td>发票类型</td>
                <td>单张开票最大额</td>
                <td>是否支持</td>
              </tr>
              <tr>
                <td>增值税普通纸质发票</td>
                <td>{{info.normalInvoiceAmount}}</td>
                <td>{{info.normalInvoiceState==1?'是':'否'}}</td>
              </tr>
              <tr>
                <td>增值税专用纸质发票</td>
                <td> {{info.specialInvoiceAmount}}</td>
                <td>{{info.specialInvoiceState==1?'是':'否'}}</td>
              </tr>
              <tr>
                <td>增值税电子普通发票</td>
                <td>{{info.electronicInvoiceAmount}}</td>
                <td>{{info.electronicInvoiceState==1?'是':'否'}}</td>
              </tr>
              <tr>
                <td>增值税专用电子发票</td>
                <td>{{ info.electronicSpecialInvoiceAmount }}</td>
                <td>{{info.electronicSpecialInvoiceState==1?'是':'否'}}</td>
              </tr>
              <tr>
                <td>增值税数电普通发票</td>
                <td>{{ info.vatDigitalElectronNormalInvoiceAmount }}</td>
                <td>{{info.vatDigitalElectronNormalInvoiceState==1?'是':'否'}}</td>
              </tr>
              <tr>
                <td>增值税数电专用发票</td>
                <td>{{ info.vatDigitalElectronSpecialInvoiceAmount }}</td>
                <td>{{info.vatDigitalElectronSpecialInvoiceState==1?'是':'否'}}</td>
              </tr>
          </table>
        </div>
      </div>
    </div>

    <div class="images-wapper">
      <span class="title">单张开票额明细</span>
      <ul class="info-wapper">
        <li>
          <div>
            <label>增值税普通纸质发票</label>
            <span>{{info.normalInvoiceAmount}}</span>
          </div>
          <div>
            <label>增值税专用纸质发票</label>
            <span>{{info.specialInvoiceAmount}}</span>
          </div>
        </li>
        <li>
          <div>
            <label>增值税电子普通发票</label>
            <span>{{info.electronicInvoiceAmount}}</span>
          </div>
          <div>
            <label>增值税专用电子发票</label>
            <span>{{info.electronicSpecialInvoiceAmount}}</span>
          </div>
        </li>
        <li>
          <div>
            <label>增值税数电普通发票</label>
            <span>{{info.vatDigitalElectronNormalInvoiceAmount}}</span>
          </div>
          <div>
            <label>增值税数电专用发票</label>
            <span>{{info.vatDigitalElectronSpecialInvoiceAmount}}</span>
          </div>
        </li>
      </ul>

    </div>

  </div>
</template>

<script>
import _invoiceContent from '@/service/invoice-content-service'
import _invoiceCompany from '@/service/invoice-company-service'
import _channel from '@/service/channel-service'
export default {
  data () {
    return {
      superRole:0,
      id: this.$route.query.id,
      parentId: this.$route.query.parentId,
      info: {},
      invoiceContents: null
    }
  },
  mounted () {
    // 查询信息
    let _loading = this.$loading({ fullscreen: true })
      _invoiceCompany.getContractCompanyDetail(this.id,response => {
      _loading.close()
      this.info = response
      this.info.normalInvoiceAmount = this.$numberUtils.divide(this.info.normalInvoiceAmount, 100)
      this.info.specialInvoiceAmount = this.$numberUtils.divide(this.info.specialInvoiceAmount, 100)
      this.info.electronicInvoiceAmount = this.$numberUtils.divide(this.info.electronicInvoiceAmount, 100)
      this.info.electronicSpecialInvoiceAmount = this.$numberUtils.divide(this.info.electronicSpecialInvoiceAmount, 100)
      this.info.vatDigitalElectronNormalInvoiceAmount = this.$numberUtils.divide(this.info.vatDigitalElectronNormalInvoiceAmount, 100)
      this.info.vatDigitalElectronSpecialInvoiceAmount = this.$numberUtils.divide(this.info.vatDigitalElectronSpecialInvoiceAmount, 100)
      this.invoiceContents = []
      _invoiceContent.getInvoiceListByName(this.contentName, response => {
        response.forEach(element => {
          var isHave = this.info.invoiceIds.indexOf(element.id)
          if (isHave != -1) {
            this.invoiceContents.push(element)
          }
        })
      })
    })
    _channel.getTabPage(res => {
      this.superRole = res.superRole
    }) 
    
   
  },
  methods: {
    goBack () {
      this.$router.back()
    }
  }
}
</script>

<style scoped>
.wapper {
  padding: 15px;
}
.header {
  margin-bottom: 15px;
}
.content-wapper {
  border: 1px solid #d6dbe5;
  border-radius: 3px;
  padding: 30px;
  padding-top: 15px;
  background: #fff;
}
.title {
  display: inline-block;
  font-size: 14px;
  font-weight: bold;
  margin: 30px 0 10px 0;
}
.info-wapper li {
  margin: 15px 0;
}
.info-wapper div {
  display: inline-block;
  width: 300px;
  position: relative;
}
.info-wapper .special {
  width: 800px;
}
.info-wapper .orderType {
  width: 550px;
}
.info-wapper span {
  margin-left: 158px;
  display: inline-block;
  vertical-align: top;
}
.info-wapper label {
  color: #909399;
  display: inline-block;
  width: 145px;
  text-align: right;
  position: absolute;
  top: 0;
}
.textarea {
  display: inline-block;
  width: 500px;
}
.images-wapper {
  border-top: 1px dashed #909399;
  margin-top: 30px;
}
.info-wapper .el-image {
  width: 210px;
  height: 100px;
  border-radius: 6px;
  margin-left: 15px;
}
.table-wapper {
  margin-left: 130px;
  width: 550px;
}
.table-wapper label {
  padding: 10px 0;
  text-align: center;
  width: 100%;
  display: block;
  font-weight: bold;
  border: 1px solid #d6dbe5;
  border-bottom: none;
}
.table-wapper table {
  border: 1px solid #d6dbe5;
  width: 100%;
}
.table-wapper td {
  padding: 10px;
  border-bottom: 1px solid #d6dbe5;
  border-right: 1px solid #d6dbe5;
}
.table-wapper tr:first-child td {
  font-weight: bold;
  background: #f9f9f9;
}
</style>